<template>
  <div class="panel-body">
      <v-tabs
        slot="extension"
        v-model="model"
        color="blue"
        slider-color="yellow"
      >
        <v-tab :key="questionnaires">Questionnaires</v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-tabs-items v-model="model">
        <v-tab-item :key="questionnaires">
          <questionnaireReport/>
        </v-tab-item>
      </v-tabs-items>
  </div>
</template>
<script>
import questionnaireReport from '@/components/QuestionnaireReport.vue'

export default {
  data: function () {
    return {
      model: null,
      questionnaires: null
    }
  },
  props: [],
  components: {
    questionnaireReport
  }
}
</script>
